import { skyBlue700, white } from "StylesConstants";

/**
 * Obtiene la configuración del badge basado en el inventory_type_id
 * Basado en front-global-components/src/shared/constants/inventoryStatus.tsx
 * donde "captured" usa skyBlue700 como badgeBg
 * @param {number} inventoryTypeId - El ID del tipo de inventario
 * @returns {Object|null} - Objeto con la configuración del badge o null
 */
export const getPropertyStatusBadge = (inventoryTypeId) => {
  // Convertir a número si es string
  const id = typeof inventoryTypeId === 'string' ? parseInt(inventoryTypeId, 10) : inventoryTypeId;

  const statusMap = {
    2: {
      label: "Captado",
      backgroundColor: skyBlue700,
      textColor: white,
      toolTipMessage: "Inmueble captado",
    },
    5: {
      label: "Captado",
      backgroundColor: skyBlue700,
      textColor: white,
      toolTipMessage: "Inmueble captado",
    }
  };

  const result = statusMap[id] || null;
  return result;
};

